import React from 'react'
import { Separator, MarginBox } from '@fs/zion-ui'
import { UserPortraitSelector } from '@fs/zion-portrait-selector'
import { number, string, func, bool, oneOfType } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import WideToggle from '../WideToggle/WideToggle'
import PointsNStreakRow from '../PointsNStreakRow'

export default function LargeStoryHeaderContent({
  onActivePersonIdChange,
  streakCount,
  points,
  isStreakCurrent,
  onStreakClick,
  onPointsClick,
  activePersonId,
  cisId,
}) {
  const { t, i18n } = useTranslation()
  const showTallHeader = !activePersonId
  return (
    <div style={{ position: 'relative', width: '100%', height: showTallHeader ? '280px' : '' }}>
      {showTallHeader && (
        <>
          <UserPortraitSelector />
          <Separator size="nano" />
        </>
      )}

      <PointsNStreakRow
        isStreakCurrent={isStreakCurrent}
        streakCount={streakCount}
        points={points}
        onStreakClick={onStreakClick}
        onPointsClick={onPointsClick}
      >
        <MarginBox marginX="sm" style={{ minWidth: '400px' }}>
          <WideToggle
            options={[
              { label: t('stories.all-stories', 'All Stories*'), value: 0 },
              {
                label: t(['stories.family-stories', 'stories.completed'], {
                  fallbackLng: i18n.language, // TODO: use 'family-stories' in english & 'completed' as fallback till other lngs are translated, remove this later
                  defaultValue: 'Family Stories*',
                }),
                value: 1,
              },
            ]}
            selectedValue={activePersonId ? 1 : 0}
            ariaLabel={t('stories.select-mode', 'Select Mode')}
            onSelect={(selection) => {
              const valueToDispatch = selection.value ? cisId : ''
              onActivePersonIdChange(valueToDispatch)
              const trackingValue = selection.value === 0 ? 'All Stories' : 'Family Stories'
              trackEvent({ event_name: `Stories:TOGGLE:SELECT_${trackingValue}` })
            }}
          />
        </MarginBox>
      </PointsNStreakRow>
    </div>
  )
}

LargeStoryHeaderContent.propTypes = {
  onActivePersonIdChange: func.isRequired,
  streakCount: number,
  points: number,
  isStreakCurrent: bool,
  onStreakClick: func.isRequired,
  onPointsClick: func.isRequired,
  activePersonId: oneOfType([string, bool]),
  cisId: string,
}
